import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableBodyV2Component, templateDataTableBodyV2 } from './DataTableBodyV2';
import styles from './DataTableBodyV2.styles.scss';
export const chameleonDataTableBodyV2 = DataTableBodyV2Component.compose({
    baseName: 'data-table-body-v2',
    template: templateDataTableBodyV2,
    styles: withStylePrefix(styles),
});
